import React from "react";
import { useMyLeaveHeaderAdminBadge } from "./use-header-admin-badge";
import { OcAppBarBadge } from "oc/components";

export const MyLeaveAdminHeaderBadge: React.FC = () => {
  const { handleClick, count } = useMyLeaveHeaderAdminBadge();
  if (count === 0) return null;

  return (
    <OcAppBarBadge
      onClick={handleClick}
      icon="mdi:bag-personal"
      value={count}
      admin
      id="my-leave-header-admin-badge"
      badgeId="my-leave-header-admin-badge-count"
    />
  );
};
